export default {"src":"/_next/static/media/icon-instagram.027b2df5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};